module.exports = "pegasus/assets/styleGroup1-twitter.png";